import { Battery, Zap, TrendingDown, DollarSign } from "lucide-react";
import { DashboardHeader } from "@/components/DashboardHeader";
import { MetricCard } from "@/components/MetricCard";
import { AgilePriceChart } from "@/components/AgilePriceChart";
import { BatteryOperationsChart } from "@/components/BatteryOperationsChart";
import { ValueCounter } from "@/components/ValueCounter";
import { LoadingState } from "@/components/LoadingState";
import { ErrorState } from "@/components/ErrorState";
import { useDashboardData } from "@/hooks/useDashboardData";

const Index = () => {
  const {
    prices,
    operations,
    isLoading,
    error,
    lastUpdate,
    valueCreated,
    latestOperation,
    currentPrice,
    refetch,
  } = useDashboardData();

  if (isLoading && !prices.length && !operations.length) return <LoadingState />;

  const socPct =
    typeof latestOperation?.state_of_charge === "number" && isFinite(latestOperation.state_of_charge)
      ? (latestOperation.state_of_charge * 100).toFixed(0)
      : "—";

  const powerOut =
    typeof latestOperation?.battery_power_output === "number" && isFinite(latestOperation.battery_power_output)
      ? latestOperation.battery_power_output.toFixed(2)
      : "—";

  const priceNow =
    typeof currentPrice?.import_price_p_per_kwh === "number" && isFinite(currentPrice.import_price_p_per_kwh)
      ? currentPrice.import_price_p_per_kwh.toFixed(2)
      : "—";

  const modeNow = latestOperation?.mode || "Unknown";

  return (
    <div className="min-h-screen bg-background">
      <DashboardHeader lastUpdate={lastUpdate} />

      <main className="container mx-auto px-6 py-8 space-y-8">
        {error && (
          <ErrorState
            message={error instanceof Error ? error.message : "Failed to fetch data"}
            onRetry={refetch}
          />
        )}

        <ValueCounter value={valueCreated} />


        <h2 className="text-lg font-semibold">Live Metrics</h2>
        <p className="text-sm text-muted-foreground">Updated every minute</p>



        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <MetricCard title="State of Charge" value={socPct} unit="%" icon={Battery} delay={0.1} />
          <MetricCard title="Power Output" value={powerOut} unit="kW" icon={Zap} delay={0.15} />
          <MetricCard title="Current Electricity Price" value={priceNow} unit="p/kWh" icon={TrendingDown} delay={0.2} />
          <MetricCard
            title="Battery Mode"
            value={modeNow}
            icon={DollarSign}
            delay={0.25}
            highlight={latestOperation?.battery_power_output !== 0}
          />
        </div>

        <h2 className="text-lg font-semibold">Yesterdays Performance Charts</h2>

        <div className="grid grid-cols-1 gap-6">
          {!prices.length && !operations.length ? (
            <div className="text-center text-sm text-muted-foreground">Loading data...</div>
          ) : (
            <>
              <AgilePriceChart prices={prices} operations={operations} />
            </>
          )}
        </div>

        <div className="text-center text-sm text-muted-foreground pb-8">
          <p>Dashboard refreshes automatically: Prices every 15 min • Ops every 60 s</p>
          <p className="mt-2">Consus Battery ID: LANZ-001-BAT1</p>
        </div>
      </main>
    </div>
  );
};

export default Index;
